module.exports = __webpack_public_path__ + "img/YAKISOBA.328d4231.jpg";